export const timestampToDateTime = (ts: string) => {
  return (new Date(ts)).toLocaleString();
};

export const timestampToDate = (ts: string) => {
  const date=new Date(ts);

  return (new Intl.DateTimeFormat('ru').format(date));
};
